import CaesarСipher from "./CaesarСipherApp";
export type Round = {
  key?: number;
  words: string;
};

export type Task = {
  id: string;
  type: string;
  rounds: Round[];
};

// Руководство:
// в tasks - идет добавление заданий,
// делящихся на раунды   (ссылки создаются автоматически, с названием заданным id)

// id — идентификатор уровня. Используется в адресной строке.
// rounds — массив раундов.Каждый раунд содержит:
// • key — ключ шифра Цезаря. Число от 1 до 33.
// • words — строка со словами, которые необходимо разгадать.

// Слова разделяются пробелами.
// Ключ применяется ко всем словам внутри одного раунда.
// Регистр букв в words не имеет значения.
// Имеется тест для проверки валидности всего, что задается в tasks.

export const tasks = [
  {
    id: "1",
    type: "1",
    rounds: [
      {
        key: 3,
        words: "сегодня вечером у нас велосипедная прогулка",
      },
      {
        key: 4,
        words: "завтра утром идем в библиотеку",
      },
    ],
  },
   {
    id: "1",
    type: "2",//перестановочный шифр
    rounds: [
      {
        words: "сегодня вечером у нас велосипедная прогулка",
      },
      {
        words: "завтра утром идем в библиотеку",
      },
    ],
  },
];
// Дополнительные параметры в адресной строке: 
// Здесь можно редактировать запись в строке поиска,
// например, название игры (изначально Caesar).
// Формы записи аргументов: /r — случайный порядок раундов. 
// Примеры:
//  /Caesar/1 
//  /Caesar/1/r 
// В обычном режиме раунды идут в том порядке, в котором они указаны в tasks. 
// В режиме /r порядок раундов перемешивается при запуске страницы.


const CaesarСipherRoutes = tasks.flatMap((task) => [
  {
    path: `/Caesar/${task.type}/${task.id}`,
    element: <CaesarСipher random={false} rounds={task.rounds} type={task.type} />,
  },
  {
    path: `/Caesar/${task.type}/${task.id}/r`,
    element: <CaesarСipher random={true} rounds={task.rounds} type={task.type} />,
  },
]);
export default CaesarСipherRoutes;
